<template>
  <ion-page class="overflow-hidden ob">
    <ion-content scrollY="false" style="width: 100vw">
      <div v-if="authLogin" class="inline-block m-4 h-full absolute top-0 left-0 onboarding-back-button">
        <button @click="
          () => {
            authLogin = false;
            magicLinkError = false;
            magicLinkSuccess = false;
          }
        " class="btn-invisible circle">
          <img src="@/assets/caret-left.svg" />
        </button>
      </div>
      <div class="onboarding">
        <div class="onboarding-content">
          <template v-if="!authLogin">
            <div class="w-full" style="z-index: 2">
              <div class="flex justify-center w-full flex-col">
                <div class="flex justify-start items-center">
                  <div class="" style="width: auto">
                    <img :src="logo" />
                  </div>
                  <div>&nbsp;</div>
                </div>

                <template v-if="globalStore.isParler">
                  <div style="
                      color: #e50038;
                      font-size: 16px;
                      font-weight: 600;
                      margin-top: 1.5em;
                      color: #000000;
                    ">
                    Welcome to the new Parler!
                  </div>

                  <div style="font-size: 24px; font-weight: 600; line-height: 32px; color: #000000;">
                    Real People. Unfiltered Voices. True Freedom.
                  </div>
                </template>
              </div>
              <form @submit.prevent="login" style="margin-top: 1.5em">
                <div :class="globalStore.isParler ? '' : 'mb-4'">
                  <p class="w-full text-center text-sm pt-2 pb-7" style="display: none" v-if="globalStore.isParler">
                    Login or sign up below.
                  </p>
                  <div v-else class="flex items-center justify-center space-x-2 my-4">
                    <p>Email</p>
                    <ion-toggle v-model="usePhone"></ion-toggle>
                    <p>Phone</p>
                  </div>
                  <div style="margin-bottom: 0.5em; color: #000000;">
                    <template v-if="inputTypeEmail">Email Address</template>
                    <template v-else>Phone Number</template>
                  </div>
                  <div :class="usePhone ? 'flex items-center justify-center text-sm' : ''" class="w-full">
                    <!-- Country Code Dropdown for Phone Number Input -->
                    <div v-if="usePhone && countryCode !== 'custom'" class="mr-2 text-xs">
                      <select id="countryCode" v-model="countryCode"
                        class="border rounded py-[9px] text-gray-700 bg-white leading-tight focus:outline-none focus:shadow-outline pl-2 pr-0"
                        style="
                          height: 60px;
                          width: 60px;
                          padding-top: 0;
                          padding-bottom: 0;
                          border: none;
                          background: rgb(245, 245, 245);
                          border-radius: 8px;
                          display: inline-flex;
                          /* justify-content: center;
                          align-items: center; */
                          text-align-last: center;
                        ">
                        <option v-for="code in countryCodes" :key="code" :value="code" class="text-center">
                          {{ code.split(" ")[0] }}
                        </option>
                        <option value="custom">Custom</option>
                        <!-- Make sure this matches exactly -->
                      </select>
                    </div>
                    <div v-else-if="usePhone" class="flex items-center mr-2 text-xs">
                      <ion-icon :icon="chevronBack" @click="countryCode = countryCodes[0]"
                        class="cursor-pointer select-none text-2xl" />
                      <input v-model="customCode" placeholder="Custom" required
                        class="onboarding-input w-20 pr-1 appearance-none border rounded py-2 text-gray-700 bg-white leading-tight focus:outline-none focus:shadow-outline"
                        style="
                          background-color: rgb(245, 245, 245);
                          border: none;
                          border-radius: 8px;
                          height: 60px;
                        " />
                    </div>
                    <!-- Email or Phone Number Input Field -->
                    <div class="w-full">
                      <input id="emailOrPhone" v-model="emailOrPhone" :type="usePhone ? 'tel' : 'email'" required
                        :placeholder="usePhone
                          ? globalStore.isParler
                            ? 'Enter your phone number...'
                            : 'Phone Number'
                          : globalStore.isParler
                            ? 'email@email.com'
                            : 'Email'
                          " @input="checkValidity" :pattern="usePhone ? '^\\d{10}$' : '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$'
                            "
                        class="appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                        style="
                          background-color: #f5f5f5;
                          border: none;
                          border-radius: 8px;
                          height: 60px;
                        " />
                    </div>
                  </div>
                  <div v-if="magicLinkError || magicLinkSuccess" class="rounded-lg text-black text-md mt-2 mb-px"
                    :class="{
                      'bg-green-200 success': magicLinkSuccess,
                      'bg-red-200 error': magicLinkError,
                    }">
                    <p>{{ magicLinkMessage }}</p>
                  </div>
                </div>
                <div class="flex" :class="!globalStore.isParler
                  ? 'flex-col'
                  : ' space-x-2 items-center justify-center w-full'
                  ">
                  <button type="submit"
                    class="btn-primary cursor-pointer w-full disabled:opacity-50 select-none px-4 focus:outline-none focus:shadow-outline"
                    :class="globalStore.isParler ? 'rounded-md py-2' : 'rounded-full py-4'
                      " @click="loginBackEnd" :disabled="!isInputValid || magicLinkSuccess">
                    Log In or Get Started
                  </button>

                  <!-- <button @click="sendMessageToiOS">Send Message to iOS</button> -->
                  <!-- <button type="button"
                          class="bg-orange-600 rounded-full hover:bg-primary text-white font-bold py-4 px-4 focus:outline-none focus:shadow-outline flex items-center justify-center mt-2">
                          <img src="../assets/reddit_icon.svg" class="w-6 mr-4" alt="" />
                          Login with Reddit
                        </button> -->
                </div>
                <p v-if="isInputValid" class="have-code text-center text-2xs cursor-pointer select-none hover:underline"
                  style="color: #000000" @click="haveCode">
                  Already have a code?
                </p>

                <div class="flex" :class="!globalStore.isParler
                  ? 'flex-col'
                  : ' space-x-2 items-center justify-center w-full gap-4 mt-4 mb-4'
                  ">
                  <div style="
                      border: 1px solid #e5e5e5;
                      border-radius: 50px;
                      width: 50px;
                      height: 50px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <button type="button" @click="togglePhone">
                      <img :src="inputTypeEmail ? phoneIcon : emailIcon" style="width: 24px; height: 24px" />
                    </button>
                  </div>

                  <div style="
                      border: 1px solid #e5e5e5;
                      border-radius: 50px;
                      width: 50px;
                      height: 50px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <button type="button" @click="loginWithGoogle" v-if="!isIOSPWA">
                      <img src="../assets/google_icon.png" style="width: 24px; height: 24px" />
                      {{ !globalStore.isParler ? "Login with Google" : "" }}
                    </button>
                  </div>

                  <!-- <div style="
                      border: 1px solid #e5e5e5;
                      border-radius: 50px;
                      width: 50px;
                      height: 50px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <button disabled type="button" @click="
                      () => {
                        return;
                      }
                    ">
                      <img src="../assets/apple.svg" style="width: 24px; height: 24px" />
                      {{ !globalStore.isParler ? "Login with Google" : "" }}
                    </button>
                  </div> -->
                </div>

                <hr />

                <div v-if="authLogin" class="flex flex-col items-center m-2">
                  <p class="text-center mb-4">
                    Code sent via {{ usePhone ? "text message" : "email" }} to
                    <span class="font-semibold">{{
                      usePhone ? countryCode + emailOrPhone : emailOrPhone
                    }}</span>
                  </p>

                  <div class="flex flex-col items-center m-2">
                    <OtpInput :numInputs="6" :errors="!!magicLinkError" :codeSent="magicLinkSuccess"
                      @on-change="handleOtpChange" @pressed-enter="validateAndSubmitAuthCode" />

                    <div v-if="showTimer" class="timer-display pt-4" :class="timer <= 5 ? 'text-red-500' : ''">
                      {{ Math.floor(timer / 60) }}:{{
                        String(timer % 60).padStart(2, "0")
                      }}
                    </div>

                    <div v-if="magicLinkError" class="mt-4 text-red-500 text-center">
                      <span class="flex items-center justify-center gap-2">
                        <ion-icon :icon="alertCircleOutline" class="text-xl"></ion-icon>
                        {{ magicLinkMessage }}
                      </span>
                    </div>
                  </div>
                </div>
                <p v-if="!globalStore.isParler" @click="haveCode" id="haveCode"
                  class="text-center text-sm text-blue-500 cursor-pointer select-none hover:underline">
                  Already have a code?
                </p>
                <p v-if="globalStore.isParler" class="text-xs"
                  style="color: #737373; margin: 3em 1.5em 0; text-align: center">
                  By creating an account you agree with our
                  <span @click.native="setActiveTab('tos')"
                    class="text-blue-500 cursor-pointer select-none hover:underline">Terms of
                    Service</span>,
                  <span @click.native="setActiveTab('privacy')"
                    class="text-blue-500 cursor-pointer select-none hover:underline">Privacy Policy</span>, and our
                  <span @click.native="setActiveTab('community')"
                    class="text-blue-500 cursor-pointer select-none hover:underline">Community Guidelines</span>.
                </p>
                <ion-accordion-group v-else>
                  <ion-accordion>
                    <ion-item slot="header" class="font-bold text-lg">Policies</ion-item>
                    <ion-list slot="content">
                      <ion-item class="cursor-pointer select-none" @click="setActiveTab('tos')">
                        Terms Of Service
                      </ion-item>
                      <ion-item class="cursor-pointer select-none" @click="setActiveTab('privacy')">
                        Privacy Policy
                      </ion-item>
                      <ion-item class="cursor-pointer select-none" @click="setActiveTab('community')">
                        Community Guidelines
                      </ion-item>
                    </ion-list>
                  </ion-accordion>
                </ion-accordion-group>
              </form>
              <!-- <div v-if="globalStore.isParler" class="flex justify-center">
  <a href="https://parler.com" target="_blank" class="text-sm rounded-md bg-neutral-100 text-black font-bold p-1 px-3 shadow-sm">Go to Parler.com</a>
</div> -->
            </div>
          </template>
          <template v-if="authLogin">
            <h1 class="mb-4" style="font-size: 18px; font-weight: 600">Verify code</h1>

            <p class="mb-8" style="font-size: 16px; font-weight: 400">
              We sent you a code, please enter it to verify your
              {{ usePhone ? "phone number" : "email address" }}.
            </p>

            <p style="font-size: 14px">Verification code</p>

            <div class="flex flex-col items-center m-2">
              <OtpInput :numInputs="6" :errors="!!magicLinkError" :codeSent="magicLinkSuccess"
                @on-change="handleOtpChange" @pressed-enter="validateAndSubmitAuthCode" />

              <div v-if="showTimer" class="timer-display pt-4" :class="timer <= 5 ? 'text-red-500' : ''">
                {{ Math.floor(timer / 60) }}:{{ String(timer % 60).padStart(2, "0") }}
              </div>

              <div v-if="magicLinkError" class="mt-4 text-red-500 text-center">
                <span class="flex items-center justify-center gap-2">
                  <ion-icon :icon="alertCircleOutline" class="text-xl"></ion-icon>
                  {{ magicLinkMessage }}
                </span>
              </div>

              <div class="w-full mt-4">
                <button class="btn-primary w-full rounded-full p-3" @click="validateAndSubmitAuthCode"
                  :disabled="!authCodeInput || authCodeInput.length !== 6">
                  Continue
                </button>
              </div>
            </div>
            <p v-if="!globalStore.isParler" @click="haveCode" id="haveCode"
              class="text-center text-sm text-blue-500 cursor-pointer select-none hover:underline">
              Already have a code?
            </p>
          </template>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {useAuthStore} from "@/stores/auth";
import {useGlobalStore} from "@/stores/global";
import logo from "../assets/parler/onboarding/logo.svg";
import {apiBackendAxios} from "@/axiosAuth";
import {
  IonAccordion,
  IonAccordionGroup,
  IonCheckbox,
  IonContent,
  IonIcon,
  IonItem,
  IonList,
  IonPage,
  IonToggle,
} from "@ionic/vue";
// import { mail, phone } from "ionicons/icons";
import emailIcon from "../assets/email.svg";
import phoneIcon from "../assets/phone.svg";
import {alertCircleOutline, chevronBack} from "ionicons/icons";
import OtpInput from "@/components/auth/OtpInput.vue";

const email = ref("");
const router = useRouter();
const password = ref("");
const store = useAuthStore();
const formMagicLink = ref(false);
const magicLinkMessage = ref("");
const magicLinkError = ref(false);
const magicLinkSuccess = ref(false);
const globalStore = useGlobalStore();
const errorMessage = ref("");
const acceptsSMS = ref(false);
const usePhone = ref(true);
const emailOrPhone = ref("");
const countryCodes = ref([
  "+1 (USA)",
  "+44 (UK)",
  "+61 (AUS)",
  "+91 (IND)",
  "+82 (ROK)",
  "+49 (GER)",
  "+33 (FRA)",
  "+39 (ITA)",
  "+81 (JPN)",
]);

const countryCode = ref(countryCodes.value[0]); // Default to the first in the list
const customCode = ref("");
const isInputValid = ref(false);
const authLogin = ref(false);
const codeSent = ref(false);
const showTimer = ref(false);
const inputTypeEmail = ref(false);

const authCodeInput = ref("");

let redirectTo = null;

watch(authCodeInput, () => {
  updateUnderline();
});

const updateUnderline = () => {
  const inputLength = authCodeInput.value.length;
  const segments = document.querySelectorAll(".segment");
  segments.forEach((segment, index) => {
    if (index < inputLength) {
      segment.classList.add("active");
    } else {
      segment.classList.remove("active");
    }
  });
};

function formatAuthCodeInput(event) {
  const inputElement = event.target;

  // Remove any non-numeric characters
  inputElement.value = inputElement.value.replace(/\D/g, "");

  if (inputElement.value.length > 6) {
    // Trim the input to 6 characters
    inputElement.value = inputElement.value.slice(0, 6);
  }

  if (inputElement.value.length === 6) {
    // Blur the input field to remove focus
    inputElement.blur();

    // Automatically submit the code if it's complete
    validateAndSubmitAuthCode();
  }

  // Optionally, adjust cursor position or handle other visual updates
}

const haveCode = () => {
  // Reset auth code digits
  if (authLogin.value) {
    authLogin.value = false;
    return;
  }
  authCodeDigits.value = new Array(6).fill("");
  showTimer.value = false;
  authLogin.value = true;
};

const timer = ref(60); // 1 minute in seconds

const countdownInterval = ref(null);

let triggered = false;

const startTimer = () => {
  if (countdownInterval.value) {
    clearInterval(countdownInterval.value);
  }

  countdownInterval.value = setInterval(() => {
    timer.value -= 1;
    if (timer.value <= 0) {
      clearInterval(countdownInterval.value);
      magicLinkSuccess.value = false;
      magicLinkError.value = true;
      magicLinkMessage.value = "The code has expired. Please request a new one.";
    }
  }, 1000);
};

const showAuthLogin = () => {
  startTimer();
  showTimer.value = true;
  timer.value = 60; // Reset timer to 15 minutes
  authLogin.value = !authLogin.value;
};

const errorTimeout = ref(null);

const handleFocus = (event) => {
  event.target.select();
};

async function validateAndSubmitAuthCode() {
  if (!validateAuthCode(authCodeInput.value)) {
    // Handle validation failure
    magicLinkError.value = true;
    magicLinkMessage.value = "Please enter a valid 6-digit code.";
    return;
  }

  try {
    await loginWithAuthCode();
  } catch (error) {
    // Error is already handled in loginWithAuthCode
    console.error("Failed to validate auth code:", error);
  }
}

function validateAuthCode(code) {
  // only allow 6 digits and numbers
  return /^\d{6}$/.test(code);
}

function setActiveTab(tab) {
  router.push({ path: "/policy", query: { tab: tab } });
}

function checkValidity(event) {
  if (usePhone.value) {
    // First, remove any non-digit characters
    let value = event.target.value.replace(/\D/g, "");

    // Then, enforce a maximum length of 10 digits
    value = value.slice(0, 10);

    // Update the input field and the bound model
    event.target.value = value;
    emailOrPhone.value = value;
  }

  // // Check if the input is valid
  isInputValid.value = event.target.validity.valid;
}

const togglePhone = () => {
  inputTypeEmail.value = !inputTypeEmail.value;
  emailOrPhone.value = "";

  if (usePhone.value) {
    //Check if the phone number is valid
    if (!/^\d{10}$/.test(emailOrPhone.value)) {
      emailOrPhone.value = "";
    }
  } else {
    //Check if the email is valid
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9][a-zA-Z0-9.-]*\\.[a-zA-Z]{2,}$/.test(
        emailOrPhone.value
      )
    ) {
      emailOrPhone.value = "";
    }
  }
  usePhone.value = !usePhone.value;
  isInputValid.value = false;
};

const isIOSPWA = computed(() => {
  return Boolean(window.webkit && window.webkit.messageHandlers);
});

const isIosSafari = computed(() => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
});

const login = async () => {
  if (!formMagicLink.value) {
    await store.login({ email: email.value, password: password.value });
  }
};

async function loginWithGoogle() {
  let response = null;

  let windowReference = window.open();
  try {
    response = await apiBackendAxios.get("/login/google");

    if (window.webkit && window.webkit.messageHandlers.openGoogleLogin) {
      window.webkit.messageHandlers.openGoogleLogin.postMessage(response.data);
      errorMessage.value = "Sent message to iOS";
    } else {
      // Fallback for web browsers
      windowReference.location = response.data;
      errorMessage.value = "Opened new window";
    }
  } catch (error) {
    console.error(error);
    errorMessage.value = error;
  }
}

// function sendMessageToiOS() {

//   try {
//     window.webkit.messageHandlers.print.postMessage("YourMessage");
//   } catch (err) {
//     errorMessage.value = "The native context does not exist yet";
//     console.error('The native context does not exist yet');
//   }
// }

const authCodeDigits = ref(new Array(6).fill(""));

const magicLinkRequested = ref(false);

async function loginBackEnd() {
  formMagicLink.value = true;

  if (magicLinkRequested.value) {
    magicLinkError.value = true;
    magicLinkMessage.value =
      "A verification request is already in progress, please wait.";
    return;
  }

  magicLinkRequested.value = true;

  const redirect = router.currentRoute.value.query.redirect || null;

  // Regular expressions for email and phone number format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?[1-9]\d{1,14}$/;

  try {
    if (usePhone.value) {
      // Prepare the full phone number
      let fullPhoneNumber = emailOrPhone.value.replace(/\D/g, ""); // Strip non-digit characters
      if (countryCode.value === "custom") {
        // Use custom code if selected
        if (!phoneRegex.test(customCode.value + fullPhoneNumber)) {
          magicLinkError.value = true;
          magicLinkMessage.value = "Please enter a valid phone number.";
          return;
        }

        // remove the + from the custom code
        if (customCode.value[0] === "+") {
          customCode.value = customCode.value.slice(1);
        }

        fullPhoneNumber = `+${customCode.value}${fullPhoneNumber}`;
      } else {
        // Extract just the numeric part of the country code for the API call
        const numericCountryCode = countryCode.value.match(/\+(\d+)/)[1];
        fullPhoneNumber = `+${numericCountryCode}${fullPhoneNumber}`;
      }

      const smsData = {
        phone: fullPhoneNumber,
      };

      if (redirect !== null) {
        smsData.redirect = redirect;
      }
      if (referralCode !== null) {
        smsData.ref = referralCode;
      }

      // Send the SMS magic link request
      await apiBackendAxios.post("/sendSmsMagicLink", smsData);
      magicLinkError.value = false;
      magicLinkSuccess.value = true;
      magicLinkMessage.value =
        "Magic link sent successfully! Check your SMS to continue.";
      showAuthLogin();
      codeSent.value = true;
    } else {
      // Handle email input
      if (!emailRegex.test(emailOrPhone.value)) {
        magicLinkError.value = true;
        magicLinkMessage.value = "Please enter a valid email address.";
        return;
      }

      const phoneData = {
        email: emailOrPhone.value,
      };

      if (redirect !== null) {
        phoneData.redirect = redirect;
      }

      if (referralCode !== null) {
        phoneData.ref = referralCode;
      }

      // Send the magic link via email
      await apiBackendAxios.post("/sendMagicLink", phoneData);

      magicLinkSuccess.value = true;
      magicLinkMessage.value =
        "Magic link sent successfully! Check your email to continue.";
      showAuthLogin();
      codeSent.value = true;
    }
  } catch (error) {
    handleMagicLinkError(error);
  }
}

let requestTimer = null;

function handleMagicLinkError(error) {
  if (error.response && error.response.data) {
    const { status, data } = error.response;
    const errorMessage = data.error || data.message || "An unexpected error occurred";

    magicLinkError.value = true;
    magicLinkMessage.value = errorMessage; // Use the more robust error message extraction

    if (status === 400) {
      console.error("Bad request error:", errorMessage);
    } else if (status === 403) {
      console.error("Forbidden access error:", errorMessage);
    }
  } else {
    // Handle cases where the error format is not as expected
    magicLinkMessage.value = "Failed to process your request. Please try again.";
  }

  // Reset magic link request state after a delay
  requestTimer = setTimeout(() => {
    magicLinkRequested.value = false;
  }, 3000);
}

function saveRedirectTo() {
  let urlParams = new URLSearchParams(window.location.search);
  let newQuery = null;

  if (urlParams.has("redirectTo")) {
    newQuery = urlParams.get("redirectTo");

    urlParams.forEach((value, key) => {
      if (key !== "redirectTo") {
        newQuery += "&" + key + "=" + value;
      }
    });
  }
  redirectTo = newQuery;
  saveCookie("redirect_url", redirectTo);
}

let referralCode = null;
function saveReferralCode() {
  //get the referral code from the URL query
  const urlParams = new URLSearchParams(window.location.search);
  const refMatch = urlParams.get("ref");
  if (refMatch) {
    // Save the referral code to a cookie
    saveCookie("referral_code", refMatch);
    // Save the referral code to a variable
    referralCode = refMatch;
  }
}

function redirectSso() {
  // To get token
  const authStore = useAuthStore();
  // Get domain
  const domainWithoutPort = getDomain();

  saveCookie("session_id", authStore.accessToken);
  window.location.href = `https://api.${domainWithoutPort}/login-sso`;
}

function saveCookie(name, value) {
  let domainWithoutPort = getDomain();

  // Create expiration date
  var now = new Date();
  var time = now.getTime();
  var expireTime = time + 20 * 36000;
  now.setTime(expireTime);

  document.cookie = `${name}=${value}; path=/; domain=${domainWithoutPort}; expires=${now.toUTCString()}`;
}

function getDomain() {
  // Get the domain without the port
  const url = new URL(window.location.origin);
  let domainWithoutPort = url.hostname;
  // Remove the 'app' subdomain
  const parts = domainWithoutPort.split(".");
  if (parts[0] === "app") {
    parts.shift();
    domainWithoutPort = parts.join(".");
  }
  return domainWithoutPort;
}

onMounted(() => {
  window.addEventListener("message", onMessage, false);

  globalStore.settings.dark_mode
    ? document.body.classList.add("dark")
    : document.body.classList.remove("dark");

  // Redirect to the App Store if on an iOS device and not in the PWA wrapper
  if (isIosSafari.value && !isIOSPWA.value && globalStore.isParler) {
    window.open("https://apps.apple.com/us/app/parler/id1402727988", "_blank");
  }

  saveRedirectTo();
  saveReferralCode();
});

onBeforeUnmount(() => {
  window.removeEventListener("message", onMessage);

  if (countdownInterval.value) {
    clearInterval(countdownInterval.value);
  }
  if (errorTimeout.value) {
    clearTimeout(errorTimeout.value);
  }
  if (requestTimer) {
    clearTimeout(requestTimer);
  }
});

async function onMessage(e) {
  if (!e.data.token) {
    return;
  }

  await Promise.all([store.setAuthenticated(e.data.token), store.setUser()]);

  const redirect = router.currentRoute.value.query.redirect || "/feed"; // Get the redirect URL or default to "/feed"
  if (!store.currentUser.accountSetup) {
    router.replace("/setup");
    return;
  }
  if (!store.currentUser.acceptTermsOfService) {
    router.replace("/policy");
    return;
  }
  router.replace(redirect);
}

// Add these methods
const handleOtpChange = (otp) => {
  authCodeInput.value = otp;
  // Clear error when user starts typing
  if (magicLinkError.value) {
    magicLinkError.value = false;
    magicLinkMessage.value = "";
  }
};

// Add this function back
async function loginWithAuthCode() {
  if (triggered) {
    return;
  }
  triggered = true;
  try {
    // Check if emailOrPhone.value is provided
    if (!emailOrPhone.value.trim()) {
      throw new Error("The identifier field is required.");
    }
    let identifier = emailOrPhone.value;
    if (usePhone.value) {
      //add country code
      if (countryCode.value === "custom") {
        if (!customCode.value) {
          throw new Error("The country code field is required.");
        }

        let cleanCustom = customCode.value.replace(/\D/g, ""); // Strip non-digit characters
        identifier = "+" + cleanCustom + emailOrPhone.value;
      } else {
        let cleanCountry = countryCode.value.replace(/\D/g, ""); // Strip non-digit characters
        identifier = "+" + cleanCountry + emailOrPhone.value;
      }
    }

    const payload = {
      identifier: identifier,
      authCode: authCodeInput.value,
    };

    const response = await apiBackendAxios.post("/authCodeLogin", payload);

    const tokenData = response.data;
    if (tokenData) {
      await store.setAuthenticated(tokenData);
      await store.setUser();

      if (store.currentUser) {
        const redirect = router.currentRoute.value.query.redirect || "/feed";

        if (!store.currentUser.accountSetup) {
          router.replace("/setup");
          return;
        }

        if (!store.currentUser.acceptTermsOfService) {
          router.replace("/policy");
          return;
        }

        if (redirectTo === null) {
          router.replace(redirect);
        } else {
          redirectSso();
        }
      }
    }
  } catch (error) {
    console.error("Login with auth code failed:", error);

    // Initialize a generic error message
    let errorMessageText = "Failed to login. Please check your identifier and code.";

    // Check if the error response includes details about the identifier or authCode
    if (error.response && error.response.data) {
      errorMessageText =
        error.response.data.identifier?.[0] ||
        error.response.data.error ||
        error ||
        "An error occurred.";
    } else if (error.message) {
      errorMessageText = error.message; // Use the error message if no response data is available
    }

    magicLinkMessage.value = errorMessageText;
    magicLinkError.value = true;
    authCodeInput.value = ""; // Clear the input field
  } finally {
    triggered = false;
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/styles/mixins.scss";

.bg-primary {
  background-color: var(--primary-color);
}

.bg-secondary {
  background-color: var(--secondary-color);
}

ion-toggle::part(track),
ion-toggle.toggle-checked::part(track) {
  background: var(--primary-color);
}

ion-checkbox {
  --size: 18px;
}

ion-checkbox::part(container) {
  border-radius: 2px;
}

@keyframes flashRed {
  0% {
    border-color: red;
  }

  100% {
    border-color: gray;
  }
}

.flash-red {
  animation: flashRed 1s;
}
</style>
